import { APIModel } from "app/state/api";
import { CMSApiCallModel } from "../../interfaces";

const pagesAccountProfile: CMSApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_CMS_API}/pages-account-profile`),
};

export default pagesAccountProfile;
